import type { ComponentType } from "react";

import { AbbyMillsRoutes, slug as abbyMillsSlug } from "./abby-mills";
import { AbhishekRaiRoutes, slug as abhishekRaiSlug } from "./abhishek-rai";
import {
  AbigailWaterstonRoutes,
  slug as abigailWaterstonSlug,
} from "./abigail-waterston";
import {
  AjaybirRatoulRoutes,
  slug as ajaybirRatoulSlug,
} from "./ajaybir-ratoul";
import {
  AlexTsarapkineRoutes,
  slug as alexTsarapkineSlug,
} from "./alex-tsarapkine";
import { AlierHuRoutes, slug as alierHuSlug } from "./alier-hu";
import { AmmadShaikhRoutes, slug as ammadShaikhSlug } from "./ammad-shaikh";
import { AmyJinRoutes, slug as amyJinSlug } from "./amy-jin";
import { AmyTalusRoutes, slug as amyTalusSlug } from "./amy-talus";
import {
  AnatolyOstapenkoRoutes,
  slug as anatolyOstapenkoSlug,
} from "./anatoly-ostapenko";
import { AndrewLiuRoutes, slug as andrewLiuSlug } from "./andrew-liu";
import { AndyZhenRoutes, slug as andyZhenSlug } from "./andy-zhen";
import {
  AneleseWebskiRoutes,
  slug as aneleseWebskiSlug,
} from "./anelese-webski";
import { ArthurCheRoutes, slug as arthurCheSlug } from "./arthur-che";
import {
  ArtyomGabtraupovRoutes,
  slug as artyomGabtraupovSlug,
} from "./artyom-gabtraupov";
import { AustinDickRoutes, slug as austinDickSlug } from "./austin-dick";
import { BeccaSabnaniRoutes, slug as beccaSabnaniSlug } from "./becca-sabnani";
import { BellaLuRoutes, slug as bellaLuSlug } from "./bella-lu";
import { BenHamiltonRoutes, slug as benHamiltonSlug } from "./ben-hamilton";
import {
  BenjaminChaconRoutes,
  slug as benjaminChaconSlug,
} from "./benjamin-chacon";
import { BrandonDangRoutes, slug as brandonDangSlug } from "./brandon-dang";
import { BrianSolomonRoutes, slug as brianSolomonSlug } from "./brian-solomon";
import {
  BronwynGemmillRoutes,
  slug as bronwynGemmillSlug,
} from "./bronwyn-gemmill";
import {
  BrooklynBrownRoutes,
  slug as brooklynBrownSlug,
} from "./brooklyn-brown";
import { CarolynKaoRoutes, slug as carolynKaoSlug } from "./carolyn-kao";
import { CatWuRoutes, slug as catWuSlug } from "./cat-wu";
import { ChanyeeKimRoutes, slug as chanyeeKimSlug } from "./chanyee-kim";
import {
  ChrisChappelleRoutes,
  slug as chrisChappelleSlug,
} from "./chris-chappelle";
import { ChrisHandelRoutes, slug as chrisHandelSlug } from "./chris-handel";
import {
  ChrisRodriguezRoutes,
  slug as chrisRodriguezSlug,
} from "./chris-rodriguez";
import {
  CristiWallaceRoutes,
  slug as cristiWallaceSlug,
} from "./cristi-wallace";
import { EmThompsonRoutes, slug as emThompsonSlug } from "./em-thompson";
import { EmilyChenRoutes, slug as emilyChenSlug } from "./emily-chen";
import { ErelGililovRoutes, slug as erelGililovSlug } from "./erel-gililov";
import { EricDingRoutes, slug as ericDingSlug } from "./eric-ding";
import {
  EtienneLamoureuxRoutes,
  slug as etienneLamoureuxSlug,
} from "./etienne-lamoureux";
import { FabioCarmoRoutes, slug as fabioCarmoSlug } from "./fabio-carmo";
import { GabeKelleyRoutes, slug as gabeKelleySlug } from "./gabe-kelley";
import {
  GabrielaTeranRoutes,
  slug as gabrielaTeranSlug,
} from "./gabriela-teran";
import {
  GeoffBeresfordRoutes,
  slug as geoffBeresfordSlug,
} from "./geoff-beresford";
import { HaoyangDingRoutes, slug as haoyangDingSlug } from "./haoyang-ding";
import {
  HarshaYeddanapudyRoutes,
  slug as harshaYeddanapudySlug,
} from "./harsha-yeddanapudy";
import {
  HarshdipSinghDeoganRoutes,
  slug as harshdipSinghDeoganSlug,
} from "./harshdip-singh-deogan";
import {
  HenriquePovedanoRoutes,
  slug as henriquePovedanoSlug,
} from "./henrique-povedano";
import {
  HenryBullinghamRoutes,
  slug as henryBullinghamSlug,
} from "./henry-bullingham";
import { IreneLimbRoutes, slug as ireneLimbSlug } from "./irene-limb";
import { IreneMaRoutes, slug as ireneMaSlug } from "./irene-ma";
import { JabranKhanRoutes, slug as jabranKhanSlug } from "./jabran-khan";
import { JackGuoRoutes, slug as jackGuoSlug } from "./jack-guo";
import { JaiMankooRoutes, slug as jaiMankooSlug } from "./jai-mankoo";
import { JamesBaoRoutes, slug as jamesBaoSlug } from "./james-bao";
import { JasmineShenRoutes, slug as jasmineShenSlug } from "./jasmine-shen";
import { JasmineZhangRoutes, slug as jasmineZhangSlug } from "./jasmine-zhang";
import { JasonHuRoutes, slug as jasonHuSlug } from "./jason-hu";
import { JeanYangRoutes, slug as jeanYangSlug } from "./jean-yang";
import {
  JeremyLeclercRoutes,
  slug as jeremyLeclercSlug,
} from "./jeremy-leclerc";
import { JessBrownRoutes, slug as jessBrownSlug } from "./jess-brown";
import { JiaTuRoutes, slug as jiaTuSlug } from "./jia-tu";
import { JocelynTeresRoutes, slug as jocelynTeresSlug } from "./jocelyn-teres";
import { JohnAdesidaRoutes, slug as johnAdesidaSlug } from "./john-adesida";
import { JohnIntraterRoutes, slug as johnIntraterSlug } from "./john-intrater";
import { JustinLiRoutes, slug as justinLiSlug } from "./justin-li";
import { KanikaAroraRoutes, slug as kanikaAroraSlug } from "./kanika-arora";
import {
  KasiaBedkowskiRoutes,
  slug as kasiaBedkowskiSlug,
} from "./kasia-bedkowski";
import {
  KatherineVidalRoutes,
  slug as katherineVidalSlug,
} from "./katherine-vidal";
import { KellyVonZupRoutes, slug as kellyVonZupSlug } from "./kelly-von-zup";
import { KendraConnRoutes, slug as kendraConnSlug } from "./kendra-conn";
import {
  KevinBenscheidtRoutes,
  slug as kevinBenscheidtSlug,
} from "./kevin-benscheidt";
import { KevinChikRoutes, slug as kevinChikSlug } from "./kevin-chik";
import { KevinGengRoutes, slug as kevinGengSlug } from "./kevin-geng";
import { KevinLaiRoutes, slug as kevinLaiSlug } from "./kevin-lai";
import { KevinLiRoutes, slug as kevinLiSlug } from "./kevin-li";
import {
  KoroshAhangarRoutes,
  slug as koroshAhangarSlug,
} from "./korosh-ahangar";
import { KristinYehRoutes, slug as kristinYehSlug } from "./kristin-yeh";
import { LanLamRoutes, slug as lanLamSlug } from "./lan-lam";
import { LaurenBlakeRoutes, slug as laurenBlakeSlug } from "./lauren-blake";
import {
  LeighJenningsRoutes,
  slug as leighJenningsSlug,
} from "./leigh-jennings";
import { LeonKempersRoutes, slug as leonKempersSlug } from "./leon-kempers";
import { LiamToranRoutes, slug as liamToranSlug } from "./liam-toran";
import { MaggieMurphyRoutes, slug as maggieMurphySlug } from "./maggie-murphy";
import { MarinaLiuRoutes, slug as marinaLiuSlug } from "./marina-liu";
import { MarkWidishRoutes, slug as markWidishSlug } from "./mark-widish";
import { MartinSitarRoutes, slug as martinSitarSlug } from "./martin-sitar";
import { MatthewBojeyRoutes, slug as matthewBojeySlug } from "./matthew-bojey";
import {
  MatthewLeandresRoutes,
  slug as matthewLeandresSlug,
} from "./matthew-leandres";
import {
  MaxVanostrilloRoutes,
  slug as maxVanostrilloSlug,
} from "./max-vanostrillo";
import { MehulPillaiRoutes, slug as mehulPillaiSlug } from "./mehul-pillai";
import { MichaelYenRoutes, slug as michaelYenSlug } from "./michael-yen";
import { MichaelZhangRoutes, slug as michaelZhangSlug } from "./michael-zhang";
import { MichalJezRoutes, slug as michalJezSlug } from "./michal-jez";
import { MirandaFittsRoutes, slug as mirandaFittsSlug } from "./miranda-fitts";
import { NakulPathakRoutes, slug as nakulPathakSlug } from "./nakul-pathak";
import { NickHowlandRoutes, slug as nickHowlandSlug } from "./nick-howland";
import {
  NikitaTashchilinRoutes,
  slug as nikitaTashchilinSlug,
} from "./nikita-tashchilin";
import { OliviaOlearyRoutes, slug as oliviaOlearySlug } from "./olivia-oleary";
import { PauloPintoRoutes, slug as pauloPintoSlug } from "./paulo-pinto";
import { PavloKuzhelRoutes, slug as pavloKuzhelSlug } from "./pavlo-kuzhel";
import { PedroAlvesRoutes, slug as pedroAlvesSlug } from "./pedro-alves";
import { PeiranHongRoutes, slug as peiranHongSlug } from "./peiran-hong";
import { PoojaJumaniRoutes, slug as poojaJumaniSlug } from "./pooja-jumani";
import { QuentinHsuRoutes, slug as quentinHsuSlug } from "./quentin-hsu";
import { QuinnBudanRoutes, slug as quinnBudanSlug } from "./quinn-budan";
import {
  RannieTeodoroRoutes,
  slug as rannieTeodoroSlug,
} from "./rannie-teodoro";
import { RebeccaGrayRoutes, slug as rebeccaGraySlug } from "./rebecca-gray";
import { RemyGordonRoutes, slug as remyGordonSlug } from "./remy-gordon";
import { RiyaPathakRoutes, slug as riyaPathakSlug } from "./riya-pathak";
import { RyanLeeRoutes, slug as ryanLeeSlug } from "./ryan-lee";
import { SagarPatelRoutes, slug as sagarPatelSlug } from "./sagar-patel";
import { SamChiengRoutes, slug as samChiengSlug } from "./sam-chieng";
import { SamanthaYeeRoutes, slug as samanthaYeeSlug } from "./samantha-yee";
import { SanjayRamanRoutes, slug as sanjayRamanSlug } from "./sanjay-raman";
import { SharonChanRoutes, slug as sharonChanSlug } from "./sharon-chan";
import {
  ShengchaoWangRoutes,
  slug as shengchaoWangSlug,
} from "./shengchao-wang";
import {
  ShilpaSubrahmanyamRoutes,
  slug as shilpaSubrahmanyamSlug,
} from "./shilpa-subrahmanyam";
import {
  SophiaArriolaGibsonRoutes,
  slug as sophiaArriolaGibsonSlug,
} from "./sophia-arriola-gibson";
import {
  SophieONeillLatulippeRoutes,
  slug as sophieONeillLatulippeSlug,
} from "./sophie-o-neill-latulippe";
import { TaneishaLugoRoutes, slug as taneishaLugoSlug } from "./taneisha-lugo";
import { TanyaMaRoutes, slug as tanyaMaSlug } from "./tanya-ma";
import {
  TaraRaoPanditRoutes,
  slug as taraRaoPanditSlug,
} from "./tara-rao-pandit";
import {
  TerenceDicksonRoutes,
  slug as terenceDicksonSlug,
} from "./terence-dickson";
import { TimHooverRoutes, slug as timHooverSlug } from "./tim-hoover";
import { TomFischerRoutes, slug as tomFischerSlug } from "./tom-fischer";
import { TomMaRoutes, slug as tomMaSlug } from "./tom-ma";
import { TonyChenRoutes, slug as tonyChenSlug } from "./tony-chen";
import { TrungNguyenRoutes, slug as trungNguyenSlug } from "./trung-nguyen";
import { UzairAshrafRoutes, slug as uzairAshrafSlug } from "./uzair-ashraf";
import { VaibhavSinghRoutes, slug as vaibhavSinghSlug } from "./vaibhav-singh";
import {
  VarunAppaswamiRoutes,
  slug as varunAppaswamiSlug,
} from "./varun-appaswami";
import {
  VictoriaSchusterRoutes,
  slug as victoriaSchusterSlug,
} from "./victoria-schuster";
import { VikasLalwaniRoutes, slug as vikasLalwaniSlug } from "./vikas-lalwani";
import { WahabAhmadRoutes, slug as wahabAhmadSlug } from "./wahab-ahmad";
import { WeiZhouRoutes, slug as weiZhouSlug } from "./wei-zhou";
import {
  WillChartrandRoutes,
  slug as willChartrandSlug,
} from "./will-chartrand";
import { WyattHaymanRoutes, slug as wyattHaymanSlug } from "./wyatt-hayman";
import { YanwuGuRoutes, slug as yanwuGuSlug } from "./yanwu-gu";
import { YaoWangRoutes, slug as yaoWangSlug } from "./yao-wang";
import { YikaiZhouRoutes, slug as yikaiZhouSlug } from "./yikai-zhou";
import { YukiMoRoutes, slug as yukiMoSlug } from "./yuki-mo";

export interface OwnerShard {
  slug: string;
  component: ComponentType;
}

export const ownerShards: OwnerShard[] = [
  { slug: abbyMillsSlug, component: AbbyMillsRoutes },
  { slug: abhishekRaiSlug, component: AbhishekRaiRoutes },
  { slug: abigailWaterstonSlug, component: AbigailWaterstonRoutes },
  { slug: ajaybirRatoulSlug, component: AjaybirRatoulRoutes },
  { slug: alexTsarapkineSlug, component: AlexTsarapkineRoutes },
  { slug: alierHuSlug, component: AlierHuRoutes },
  { slug: ammadShaikhSlug, component: AmmadShaikhRoutes },
  { slug: amyJinSlug, component: AmyJinRoutes },
  { slug: amyTalusSlug, component: AmyTalusRoutes },
  { slug: anatolyOstapenkoSlug, component: AnatolyOstapenkoRoutes },
  { slug: andrewLiuSlug, component: AndrewLiuRoutes },
  { slug: andyZhenSlug, component: AndyZhenRoutes },
  { slug: aneleseWebskiSlug, component: AneleseWebskiRoutes },
  { slug: arthurCheSlug, component: ArthurCheRoutes },
  { slug: artyomGabtraupovSlug, component: ArtyomGabtraupovRoutes },
  { slug: austinDickSlug, component: AustinDickRoutes },
  { slug: beccaSabnaniSlug, component: BeccaSabnaniRoutes },
  { slug: bellaLuSlug, component: BellaLuRoutes },
  { slug: benjaminChaconSlug, component: BenjaminChaconRoutes },
  { slug: brandonDangSlug, component: BrandonDangRoutes },
  { slug: bronwynGemmillSlug, component: BronwynGemmillRoutes },
  { slug: benHamiltonSlug, component: BenHamiltonRoutes },
  { slug: brianSolomonSlug, component: BrianSolomonRoutes },
  { slug: brooklynBrownSlug, component: BrooklynBrownRoutes },
  { slug: carolynKaoSlug, component: CarolynKaoRoutes },
  { slug: catWuSlug, component: CatWuRoutes },
  { slug: chanyeeKimSlug, component: ChanyeeKimRoutes },
  { slug: chrisChappelleSlug, component: ChrisChappelleRoutes },
  { slug: chrisHandelSlug, component: ChrisHandelRoutes },
  { slug: chrisRodriguezSlug, component: ChrisRodriguezRoutes },
  { slug: cristiWallaceSlug, component: CristiWallaceRoutes },
  { slug: emThompsonSlug, component: EmThompsonRoutes },
  { slug: emilyChenSlug, component: EmilyChenRoutes },
  { slug: erelGililovSlug, component: ErelGililovRoutes },
  { slug: ericDingSlug, component: EricDingRoutes },
  { slug: etienneLamoureuxSlug, component: EtienneLamoureuxRoutes },
  { slug: fabioCarmoSlug, component: FabioCarmoRoutes },
  { slug: gabeKelleySlug, component: GabeKelleyRoutes },
  { slug: gabrielaTeranSlug, component: GabrielaTeranRoutes },
  { slug: geoffBeresfordSlug, component: GeoffBeresfordRoutes },
  { slug: haoyangDingSlug, component: HaoyangDingRoutes },
  { slug: harshaYeddanapudySlug, component: HarshaYeddanapudyRoutes },
  { slug: harshdipSinghDeoganSlug, component: HarshdipSinghDeoganRoutes },
  { slug: henriquePovedanoSlug, component: HenriquePovedanoRoutes },
  { slug: henryBullinghamSlug, component: HenryBullinghamRoutes },
  { slug: ireneLimbSlug, component: IreneLimbRoutes },
  { slug: ireneMaSlug, component: IreneMaRoutes },
  { slug: jabranKhanSlug, component: JabranKhanRoutes },
  { slug: jackGuoSlug, component: JackGuoRoutes },
  { slug: jaiMankooSlug, component: JaiMankooRoutes },
  { slug: jamesBaoSlug, component: JamesBaoRoutes },
  { slug: jasmineShenSlug, component: JasmineShenRoutes },
  { slug: jasmineZhangSlug, component: JasmineZhangRoutes },
  { slug: jasonHuSlug, component: JasonHuRoutes },
  { slug: jeanYangSlug, component: JeanYangRoutes },
  { slug: jeremyLeclercSlug, component: JeremyLeclercRoutes },
  { slug: jessBrownSlug, component: JessBrownRoutes },
  { slug: jiaTuSlug, component: JiaTuRoutes },
  { slug: jocelynTeresSlug, component: JocelynTeresRoutes },
  { slug: johnAdesidaSlug, component: JohnAdesidaRoutes },
  { slug: johnIntraterSlug, component: JohnIntraterRoutes },
  { slug: justinLiSlug, component: JustinLiRoutes },
  { slug: kanikaAroraSlug, component: KanikaAroraRoutes },
  { slug: kasiaBedkowskiSlug, component: KasiaBedkowskiRoutes },
  { slug: katherineVidalSlug, component: KatherineVidalRoutes },
  { slug: kellyVonZupSlug, component: KellyVonZupRoutes },
  { slug: kendraConnSlug, component: KendraConnRoutes },
  { slug: kevinBenscheidtSlug, component: KevinBenscheidtRoutes },
  { slug: kevinChikSlug, component: KevinChikRoutes },
  { slug: kevinGengSlug, component: KevinGengRoutes },
  { slug: kevinLaiSlug, component: KevinLaiRoutes },
  { slug: kevinLiSlug, component: KevinLiRoutes },
  { slug: koroshAhangarSlug, component: KoroshAhangarRoutes },
  { slug: kristinYehSlug, component: KristinYehRoutes },
  { slug: lanLamSlug, component: LanLamRoutes },
  { slug: laurenBlakeSlug, component: LaurenBlakeRoutes },
  { slug: leighJenningsSlug, component: LeighJenningsRoutes },
  { slug: leonKempersSlug, component: LeonKempersRoutes },
  { slug: liamToranSlug, component: LiamToranRoutes },
  { slug: maggieMurphySlug, component: MaggieMurphyRoutes },
  { slug: marinaLiuSlug, component: MarinaLiuRoutes },
  { slug: markWidishSlug, component: MarkWidishRoutes },
  { slug: martinSitarSlug, component: MartinSitarRoutes },
  { slug: matthewBojeySlug, component: MatthewBojeyRoutes },
  { slug: matthewLeandresSlug, component: MatthewLeandresRoutes },
  { slug: maxVanostrilloSlug, component: MaxVanostrilloRoutes },
  { slug: mehulPillaiSlug, component: MehulPillaiRoutes },
  { slug: michaelYenSlug, component: MichaelYenRoutes },
  { slug: michaelZhangSlug, component: MichaelZhangRoutes },
  { slug: michalJezSlug, component: MichalJezRoutes },
  { slug: mirandaFittsSlug, component: MirandaFittsRoutes },
  { slug: nakulPathakSlug, component: NakulPathakRoutes },
  { slug: nickHowlandSlug, component: NickHowlandRoutes },
  { slug: nikitaTashchilinSlug, component: NikitaTashchilinRoutes },
  { slug: oliviaOlearySlug, component: OliviaOlearyRoutes },
  { slug: pauloPintoSlug, component: PauloPintoRoutes },
  { slug: pavloKuzhelSlug, component: PavloKuzhelRoutes },
  { slug: pedroAlvesSlug, component: PedroAlvesRoutes },
  { slug: peiranHongSlug, component: PeiranHongRoutes },
  { slug: poojaJumaniSlug, component: PoojaJumaniRoutes },
  { slug: quentinHsuSlug, component: QuentinHsuRoutes },
  { slug: quinnBudanSlug, component: QuinnBudanRoutes },
  { slug: rannieTeodoroSlug, component: RannieTeodoroRoutes },
  { slug: rebeccaGraySlug, component: RebeccaGrayRoutes },
  { slug: remyGordonSlug, component: RemyGordonRoutes },
  { slug: riyaPathakSlug, component: RiyaPathakRoutes },
  { slug: ryanLeeSlug, component: RyanLeeRoutes },
  { slug: sagarPatelSlug, component: SagarPatelRoutes },
  { slug: samChiengSlug, component: SamChiengRoutes },
  { slug: samanthaYeeSlug, component: SamanthaYeeRoutes },
  { slug: sanjayRamanSlug, component: SanjayRamanRoutes },
  { slug: sharonChanSlug, component: SharonChanRoutes },
  { slug: shengchaoWangSlug, component: ShengchaoWangRoutes },
  { slug: shilpaSubrahmanyamSlug, component: ShilpaSubrahmanyamRoutes },
  { slug: sophiaArriolaGibsonSlug, component: SophiaArriolaGibsonRoutes },
  { slug: sophieONeillLatulippeSlug, component: SophieONeillLatulippeRoutes },
  { slug: taneishaLugoSlug, component: TaneishaLugoRoutes },
  { slug: tanyaMaSlug, component: TanyaMaRoutes },
  { slug: taraRaoPanditSlug, component: TaraRaoPanditRoutes },
  { slug: terenceDicksonSlug, component: TerenceDicksonRoutes },
  { slug: timHooverSlug, component: TimHooverRoutes },
  { slug: tomFischerSlug, component: TomFischerRoutes },
  { slug: tomMaSlug, component: TomMaRoutes },
  { slug: tonyChenSlug, component: TonyChenRoutes },
  { slug: trungNguyenSlug, component: TrungNguyenRoutes },
  { slug: uzairAshrafSlug, component: UzairAshrafRoutes },
  { slug: vaibhavSinghSlug, component: VaibhavSinghRoutes },
  { slug: varunAppaswamiSlug, component: VarunAppaswamiRoutes },
  { slug: victoriaSchusterSlug, component: VictoriaSchusterRoutes },
  { slug: vikasLalwaniSlug, component: VikasLalwaniRoutes },
  { slug: wahabAhmadSlug, component: WahabAhmadRoutes },
  { slug: weiZhouSlug, component: WeiZhouRoutes },
  { slug: willChartrandSlug, component: WillChartrandRoutes },
  { slug: wyattHaymanSlug, component: WyattHaymanRoutes },
  { slug: yanwuGuSlug, component: YanwuGuRoutes },
  { slug: yaoWangSlug, component: YaoWangRoutes },
  { slug: yikaiZhouSlug, component: YikaiZhouRoutes },
  { slug: yukiMoSlug, component: YukiMoRoutes },
];
